import { Injectable, inject } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { TranslateService } from '@ngx-translate/core';
import { MessageDialogComponent } from '../components/message-dialog/message-dialog.component';

/**
 * Shows the single, consistent "your screen is out of date" experience for stale-data conflicts.
 *
 * Used in two places:
 *  - the HTTP interceptor, when the backend rejects an action with the stale-data 409, and
 *  - list screens that detect staleness client-side (a status re-check) before they act.
 *
 * Both call {@link showAndReload}, so the user always sees the same centered, must-acknowledge dialog
 * and the page reloads on OK to show the current data.
 */
@Injectable({ providedIn: 'root' })
export class StaleDataDialogService {
  private readonly dialog = inject(MatDialog);
  private readonly translate = inject(TranslateService);

  /**
   * Opens the centered, modal "out of date" dialog and reloads the page once the user clicks OK.
   */
  showAndReload(): void {
    this.dialog
      .open(MessageDialogComponent, {
        disableClose: true,
        data: {
          title: this.translate.instant('stale-data.title'),
          message: this.translate.instant('stale-data.message'),
        },
      })
      .afterClosed()
      .subscribe(() => window.location.reload());
  }
}
